var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    {
      staticClass: "inactivity-message",
      attrs: {
        "md-active": _vm.isOpened,
        "md-click-outside-to-close": false,
        "md-close-on-esc": false
      },
      on: {
        "update:mdActive": function($event) {
          _vm.isOpened = $event
        },
        "update:md-active": function($event) {
          _vm.isOpened = $event
        }
      }
    },
    [
      _c("div", { staticClass: "inactivity-message__popup" }, [
        _c("h2", [_vm._v(_vm._s(_vm.i18n.inm_session_timeout()))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.i18n.inm_session_timeout_descr()))]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "inactivity-message__buttons" },
          [
            _c(
              "md-button",
              { staticClass: "btn md-primary", on: { click: _vm.cancel } },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.i18n.lbl_cancel()) + "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "md-button",
              { staticClass: "btn md-primary", on: { click: _vm.logout } },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.i18n.lbl_logout()) +
                    " (" +
                    _vm._s(_vm.leftToLogout) +
                    ")\n      "
                )
              ]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c92c23c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c92c23c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/common/messages/InactivityMessage.vue
// module id = bSsK
// module chunks = 1